import script from "./ImageDynamicLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageDynamicLayout.vue?vue&type=script&setup=true&lang=js"

import "./ImageDynamicLayout.vue?vue&type=style&index=0&id=06787cde&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06787cde"]])

export default __exports__